import { Element } from "react-scroll";
import styled from "styled-components";
import { useContext } from "react";
import { LanguageContext } from "../../components/LanguageContext";
import sabWork from "../../assets/sab-work.webp";
import Mixing from "../../assets/mixing.svg";
import Mastering from "../../assets/diamond.svg";
import Recording from "../../assets/microphone.svg";
import Speaker from "../../assets/audioSpeakers.svg";

import Card from "../../components/Card";

const About = () => {
  const { language } = useContext(LanguageContext);
  const text = {
    english: {
      title: "Get the sound you deserve",
      first: "Recording",
      firstP:
        "I can record all of your performances and assist you throughout the process to get the best and most alive raw tracks possible.",
      second: "Mixing",
      secondP:
        "I can take raw tracks I have recorded with you or that you have recorded yourself and bring them to a finished powerful mix that will stand up to the standards of today's music industry.",
      thirdP:
        "I can master your songs to make sure they will translate well into any listening device.",
    },
    french: {
      title: "Obtenez votre meilleur son",
      first: "Enregistrement",
      firstP:
        "Je peux enregistrer vos performances et vous orienter tout au long du processus afin d'obtenir les meilleures tracks possibles.",
      second: "Mixage",
      secondP:
        "Je peux prendre des tracks enregistrés avec vous ou que vous avez enregistrés vous-même et les transformer en un mix puissant et clair qui répondra aux standards de l'industrie musicale d'aujourd'hui.",
      thirdP:
        "Je peux masteriser votre musique et faire en sorte qu'elle s'interprète adéquatement sur n'importe quel système d'écoute.",
    },
  };

  return (
    <Wrapper name="about">
      <Content>
        <Title>{text[language].title}</Title>
        <CardWrap>
          <Card
            title={text[language].first}
            text={text[language].firstP}
            icon={Recording}
            animation={"fadeInLeft"}
          />
          <Card
            title={text[language].second}
            text={text[language].secondP}
            icon={Mixing}
            animation={"fadeInUp"}
          />
          <Card
            title={"Mastering"}
            text={text[language].thirdP}
            icon={Speaker}
            animation={"fadeInRight"}
          />
        </CardWrap>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled(Element)`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: clamp(640px, 92vh, 92vh);
  background: linear-gradient(
      0deg,
      rgba(53, 124, 130, 1) 0%,
      rgba(53, 124, 130, 0.5) 15%,
      rgba(53, 124, 130, 0.5) 85%,
      rgba(53, 124, 130, 1) 100%
    ),
    url(${sabWork});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 20px;
  @media (max-width: 1000px) {
    height: 100%;
  }
`;
const CardWrap = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
  /* margin-top: 60px; */
`;

const Title = styled.h2`
  color: white;
  font-size: 3.6rem;
  /* margin-top: -60px; */
  text-align: center;
  @media (max-width: 1000px) {
    font-size: 2.3rem;
    margin-bottom: 12px;
  }
`;
const Content = styled.div`
  width: 90%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
  @media (max-width: 1000px) {
  }
`;
export default About;
